/**
 * Brand palette — "Fresh Ledger".
 * navy  = ink (sidebar, hero band, text.primary)   · 900 is the historic sidebar #131B4D
 * leaf  = highlighter / primary CTA                · 500 is the logo "my" green
 * sand  = warm neutrals (never blue-grey)
 * amber / red = status palettes (Tailwind-derived so 50–900 all resolve)
 *
 * Hard rule: white text is never placed on leaf.500 — green fills always carry navy.900 text.
 */
export const colors = {
  navy: {
    50: "#EEF0FA",
    100: "#DADDF4",
    200: "#B5BBE8",
    300: "#8B95D8",
    400: "#6370C3",
    500: "#454FA8",
    600: "#313A8C",
    700: "#232B72",
    800: "#1B1F5E",
    900: "#131B4D",
    950: "#0B1035",
  },
  leaf: {
    50: "#F0F9EC",
    100: "#DDF1D3",
    200: "#BDE4AB",
    300: "#98D480",
    400: "#7CC865",
    500: "#6BBF59",
    600: "#52A343",
    700: "#3F8434",
    800: "#326828",
    900: "#27511F",
  },
  sand: {
    50: "#FAF9F6",
    100: "#F3F1EB",
    200: "#E8E5DC",
    300: "#D6D2C6",
    400: "#B3AEA1",
    500: "#8C877A",
    600: "#6B665B",
    700: "#4E4A42",
    800: "#33302A",
    900: "#1F1D19",
  },
  amber: {
    50: "#FFFBEB",
    100: "#FEF3C7",
    200: "#FDE68A",
    300: "#FCD34D",
    400: "#FBBF24",
    500: "#F59E0B",
    600: "#D97706",
    700: "#B45309",
    800: "#92400E",
    900: "#78350F",
  },
  red: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#DC2626",
    600: "#B91C1C",
    700: "#991B1B",
    800: "#991B1B",
    900: "#7F1D1D",
  },
  brand: { navy: "#131B4D", ink: "#1B1464", green: "#6BBF59" },
};
